import { render, staticRenderFns } from "./success_return.vue?vue&type=template&id=4c710180"
import script from "./success_return.vue?vue&type=script&lang=js"
export * from "./success_return.vue?vue&type=script&lang=js"
import style0 from "./success_return.vue?vue&type=style&index=0&id=4c710180&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports